import React from 'react'
import styled from '@emotion/styled'

const WidgetWrapper = styled.div`
  border: 1px solid #eaedf3;
  border: 1px solid var(--border-color-base);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 4%);
  border-radius: 4px;
  background: #fff;
  background: var(--bg-main);
  display: block;

  > h2 {
    font-weight: 500;
  }
`

type Props = {
  children?: any
  className?: string
}

const Widget = ({ className, children }: Props) => (
  <WidgetWrapper className={className}>{children}</WidgetWrapper>
)

export default Widget
